//this is the central store for BackboneRelational models
export default {};
